<template>
  <div v-if="chartShow">
    <PieChart class="max-width-450" :chart-data="chartRegisterData" />
  </div>
</template>

<script>
  import PieChart from '../charts/Pie.js'

  export default {
    components: { PieChart },
    props: ['data'],
    data() {
      return {
        chartShow: false,

        chartRegisterData: {
          labels: [],
          datasets: [
            {
              label: 'Register',
              data: [],
              backgroundColor: [],
            },
          ],
        },
      }
    },
    methods: {
      async readRegisterChart() {
        let preRegisters = this.data.preRegister
        for (let index = 0; index < preRegisters.length; index++) {
          let register = preRegisters[index]
          this.chartRegisterData.labels.push(
            register._id ? 'Pré-enregistrement' : 'Manuelle'
          )
          this.chartRegisterData.datasets[0].data.push(register.count)
          if (register._id === true) {
            this.chartRegisterData.datasets[0].backgroundColor.push(
              'rgb(180, 60, 60)'
            )
          }
          if (register._id === false) {
            this.chartRegisterData.datasets[0].backgroundColor.push(
              'rgb(60, 60, 255)'
            )
          }
        }
        this.chartShow = true
      },
    },
    mounted() {
      this.readRegisterChart()
    },
  }
</script>

<style scoped>
  .max-width-450 {
    max-width: 450px;
  }
</style>
